<template>
  <f-box 
    class="document-list-item margin-bottom-3 has-no-col-gap"
    grid
  >
    <div class="is-col-5 is-grid">
      <div class="is-col-3 document-list-item--status is-aligned">
        <p>
          <i :class="[
            `uil`,
            docState,
            docStatus,
          ]"></i>
        </p>

        <p class="m-left-2">
          <small>
            {{ formatDate(document.date, 'DD.MM.YY') }}
          </small>
        </p>
      </div>

      <div class="is-col-3 is-aligned-right">
        <p>
          <small>
            {{ displayAmount(document.total.net) }} €
          </small>
        </p>
      </div>

      <div class="is-col-3 is-aligned-right">
        <p>
          <small>
            {{ displayAmount(document.total.ht) }} €
          </small>
        </p>
      </div>

      <div class="is-col-3">
        <p>
          <small>
            {{ displayAmount(document.tva.total) }} €
          </small>
        </p>
      </div>
    </div>

    <div class="is-col-7 is-grid">
      <div class="is-col-4 is-overflow-hidden">
        <p class="is-ellipsis">
          <small v-if="isAdmin || isSupport">
            <router-link 
              :to="{ 
                name: 'document-infos', 
                params: { 
                  document_id: document._id,
                  id: userId
                } 
              }"
              class="color-text"
            >
              {{ document.client.name }}
            </router-link>
          </small>

          <small v-if="!isAdmin && !isSupport">
            {{ document.client.name }}
          </small>
        </p>
      </div>

      <div class="is-col-4 is-overflow-hidden">
        <p class="is-ellipsis">
          <small v-if="isAdmin || isSupport">
            <router-link 
              :to="{ 
                name: 'document-infos', 
                params: { 
                  document_id: document._id,
                  id: userId
                }  
              }"
              class="color-text"
            >
              {{ document.numerotation }}
            </router-link>
          </small>

          <small v-if="!isAdmin && !isSupport">
            {{ document.numerotation_freebe }}
          </small>
        </p>
      </div>

      <div class="is-col-3 is-overflow-hidden">
        <p class="is-ellipsis">
          <small v-if="isAdmin || isSupport">
            <router-link 
              :to="{ 
                name: 'document-infos', 
                params: { 
                  document_id: document._id,
                  id: userId
                }  
              }"
              class="color-text"
            >
              {{ document.numerotation_freebe }}
            </router-link>
          </small>

          <small v-if="!isAdmin && !isSupport">
            {{ document.numerotation_freebe }}
          </small>
        </p>
      </div>

      <div class="is-col-1 document-list-item--status">
        <p>
          <i 
            :class="[
              `uil`,
              {
                'uil-envelope is-success': document.email.sent, 
              }
            ]"
          ></i>
        </p>
      </div>
    </div>
  </f-box>
</template>

<script>
  import { ref, computed, watch } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import useRoles from '@composables/use-roles'
  import useDate from '@composables/use-date'
  import useNumbers from '@composables/use-numbers'
  import router from '@core/router'
  
  export default {
    props: {
      document: {
        type: Object,
        required: true,
      },

      selectable: {
        type: Boolean, 
        default: true,
      },

      isSelected: {
        type: Boolean, 
        default: false,
      },
    },

    setup (props, context) {
      const { me } = useStore('@admin/users')
      const { isAdmin, isSupport } = useRoles(me)
      const selected = ref(!!props.selected)
      const userId = computed(() => 
        router.currentRoute.value.params.id
      )

      function toggleSelection () {
        context.emit('toggle-selection', props.document._id, !!props.isSelected)
      }

      const mapStates = {
        'pending': 'is-info',
        'paid': 'is-success',
        'late': 'is-danger',
        'partially_paid': 'is-info',
        'cancelled': 'is-blue-dark',
      }

      const mapStatuses = {
        'draft': 'uil-file-alt',
        'verification': 'uil-file-alt',
        'validation': 'uil-file-check',
        'sent': 'uil-file-check',
        'reedition': 'uil-file-alt',
      }

      const docState = computed(() => 
        props.document.archived 
        ? 'is-disabled' 
        : mapStates[props.document.state] || 'is-disabled'
      )

      const docStatus = computed(() => 
        props.document.archived 
        ? 'uil-file-times'
        : props.document.imported 
        ? 'uil-file-upload'
        : mapStatuses[props.document.status] || 'uil-file-question'
      )

      watch(() => props.isSelected, newValue => {
        if (newValue != selected.value) {
          selected.value = !!newValue
        }
      })

      return {
        isAdmin,
        isSupport,
        selected,
        docState,
        docStatus,
        toggleSelection,
        ...useDate(),
        ...useNumbers(),
        userId,
      }
    }
  }
</script>

<style lang="scss">
  .document-list-item {
    padding: 0.45rem 1rem 0.45rem 1rem;

    &--status {
      i {
        font-size: 20px;
      }
    }
  }
</style>